
import utils from '@/utils'

const { clientSecretPassport, clientIdPassport, hostPassport } = utils.envVariables

export function getAccessToken (code) {
  return this.fetch({
    method: 'GET',
    url: `${hostPassport}/oauth2/token`,
    isReturntype: 1,
    params: {
      code,
      client_id: clientIdPassport,
      client_secret: clientSecretPassport,
      grant_type: 'authorization_code',
      access_type: 'offline'
    }
  }).then(res => {
    if (res.access_token) {
      localStorage.setItem('accessTokenInfo', JSON.stringify(res))
    }
    return res
  })
}

export function getUserinfoByAccessToken (token) {
  return this.fetch({
    method: 'GET',
    url: `${hostPassport}/api/user/info`,
    isReturntype: 1,
    params: {
      access_token: token
    }
  }).then(res => {
    localStorage.setItem('userinfo', JSON.stringify(res))
    return res
  })
}

export function userinfo (params) {
  return this.fetch({
    method: 'GET',
    url: 'mini-program-server/api/login/info/v2/active/userinfo',
    params
  })
}
export function accredit (params) {
  return this.fetch({
    method: 'GET',
    url: 'wx-server/weixin/login/v1/exchange/wxtoken',
    params
  })
}
export function getToken (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall/v1/store/info',
    params
  })
}
export function getLoginType (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall/get/login_type',
    params
  })
}
// 判断是否有审核中的申请

export function coApplyCheck (params) {
  return this.fetch({
    method: 'GET',
    url: 'wx-server/copartner/v1/coApplyCheck',
    params
  })
}

// 给后端记录当前的用户信息
export function setUserInfoToDBA (params) {
  return this.fetch({
    method: 'GET',
    isState: false,
    isShowError: false,
    url: `${process.env.VUE_APP_deviceSource}/cors/ccuserlogin/insertUserAndGetDevice.coocaa`,
    params
  })
}

// 调用用户电视源信息
export function getDeviceList (params) {
  return this.fetch({
    method: 'GET',
    url: `${process.env.VUE_APP_deviceSource}/cors/wxUserInfoAPI/getDeviceList`,
    // url: 'https://wx.coocaa.com/cors/wxUserInfoAPI/getDeviceList',
    params
  })
}
